module.exports = __webpack_public_path__ + "assets/ea70edb53461eaca1cb28646a9eb71ee.png";